<template>
    <!-- εαν δεν υπάρχουν νέες καταχωρήσεις από εφέδρους, εμφάνισε ένα μήνυμα-->
    <div v-if="show" class="alert alert-success alert-dismissible fade show col-md-8" role="alert" style=" margin-left: 20%;">
        Δεν υπάρχουν δημιουργημένες ομάδες.
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- εαν υπάρχουν νέες καταχωρήσεις από εφέδρους, εμφάνισε τον πίνακα με τις λεπτομέριες-->
    <div v-else class="container">
        <br>
        <br>
        
        <h2>Εμφάνιση Δημιουργημένων Ομάδων</h2>
        <div>
            <router-link :to="{name: 'CreateTeamView'}" class="btn btn-outline-success">Νέα Ομάδα</router-link>
        </div>
        <br>
        <br>

        <table class="table table-hover table-bordered"  id="table" data-toggle="table">
            <thead>
                <tr>
                    <th>Όνομα Ομάδας</th>
                    <th>Περιγραφή Ομάδας</th>
                    <th>Κατάσταση</th>
                </tr>
            </thead>
            <tbody>
                <tr :id="item.id" v-for="item in tbldata" :key="item.id">
                    <td id="onoma">{{item.onoma}}</td>
                    <td id="perigrafh">{{item.perigrafh}}</td>
                    <td id="status">{{item.status}}</td>
                    <td>
                        <div>
                            <button type="button" class="btn btn-outline-primary" v-on:click.prevent="modal(item)">
                                Άνοιγμα
                            </button>

                            <!-- Modal -->
                            <div class="modal fade" :id="'ModalValidate-'+item.id" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                                    <div class="modal-content">

                                        <div class="modal-header">
                                            <h5 class="modal-title" id="exampleModalScrollableTitle">
                                                Mέλη Ομάδας:
                                            </h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                          

                                                <div v-if="show_404_efedros" class="alert alert-danger alert-dismissible fade show col-md-12" role="alert">
                                                    Ο έφεδρος που ζητήσατε δεν μπόρεσε να βρεθεί. Παρακαλούμε ελέγξτε τον ΑΣΜ του και δοκιμάστε εκ νέου.
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>

                                                <SearchEfedrosForm @error = "onSearchError" :rows="tbldataefedroi"></searchEfedrosForm>
                                                <TeamTable :rows.sync="tbldataefedroi"></TeamTable>
   
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-success" v-on:click.prevent="save_group(item)">Αποθήκευση</button>
                                            <button type="button" class="btn btn-info" data-dismiss="modal">Κλείσιμο</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <button type="button" class="btn btn-outline-danger" v-on:click.prevent="delete_team_pre(item.id)">
                            Διαγραφή
                        </button>

                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Επιβεβαίωση διαγραφής ομάδας</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        Θα πρέπει να επιβεβαιώσετε την διαγραφή της ομάδας.
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-danger" v-on:click.prevent="delete_team()">Διαγραφή</button>
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
         <Message v-if="msgVisible" v-bind:msgClass="msgClass" v-bind:message="message"></Message>
    </div>
</template>

<script>
    import {HTTP} from "../main.js";
    import TeamTable from "../components/teams/TeamTable"
    import SearchEfedrosForm from "../components/teams/SearchEfedrosForm"
    import Message from '../components/Message.vue'

    export default {
        name: "ManageTeams",
        components: { SearchEfedrosForm, TeamTable, Message },
        data: function(){
            return {
                show: false,
                show_404_efedros: false,
                deleted_users: [],
                added_users: [],
                tbldata: [],
                tbldataefedroi: [],
                team_id: "",
                message: "",
                msgClass: "",
                msgVisible: ""
            }
        },
        created() {
            if (this.$store.getters.userRole !== "ROLE_MANAGER" && this.$store.getters.userRole !== "ROLE_SXHMATISMOS") this.$router.push('home');
        },
        mounted() {
            let url = "/groups/" + this.$store.getters.meeResponsible;

            this.$store.dispatch('loading');

            HTTP.get(url).then(response => {
                let resp = response.data;

                let res = resp.responseData;

                for(let i=0; i<res.length; i++)
                {
                    this.tbldata.push({
                        'onoma': res[i].onoma,
                        'perigrafh': res[i].perigrafh,
                        'status': res[i].status,
                        'id': res[i].id,
                    });
                }

            })
            .catch((error) => console.error(error))
            .finally(() => this.$store.dispatch('stop_loading'));
        },
        methods: {

            setMsg(status,msg){
                this.message = msg;
                this.msgClass = status;
                this.msgVisible = true;
            },

            onSearchError: function(show_error, error_message){
                this.show_404_efedros = true;
                return;
            },
            save_group (item) {
                let arrEfsa = [];
                let oTable = document.getElementById('fin_efedroi');

                if(oTable) {
                    let rowLength = oTable.rows.length;
                    for (let i = 1; i < rowLength; i++) {
                        let oCells = oTable.rows.item(i).cells;
                        arrEfsa.push(oCells.item(0).innerHTML);
                    }
                }

                this.$store.dispatch('loading');

                let url = "/groups/update/" + item.id;

                let data = {
                  'efedroi' : arrEfsa
                };

                HTTP.post(url, data).then(response => {
                    let resp = response.data;
                    this.setMsg('success',resp.message);
                })
                .catch((error) => {
                    console.error(error);
                    let resp = error.response;
                    this.setMsg('danger',(resp.data.errorMessage)? resp.data.errorMessage : resp.statusText );
                })
                .finally(() => this.$store.dispatch('stop_loading'));

            },

            remove_efedros (asm) {
                var row = document.getElementById(asm);
                row.parentNode.removeChild(row);
            },

            delete_team_pre (id) {
                this.team_id = id;
                $('#exampleModal').modal('show');
            },

            delete_team () {
                this.$store.dispatch('loading');
                let url = "/groups/delete/" + this.team_id;
                HTTP.post(url).then(response => {
                    var resp = response.data;
                    $('#exampleModal').modal('hide');

                    var row = document.getElementById(this.team_id);
                    row.parentNode.removeChild(row);
                    this.setMsg('success',resp.message);
                }).catch((error) => {
                    console.error(error);
                    let resp = error.response;
                    this.setMsg('danger',(resp.data.errorMessage)? resp.data.errorMessage : resp.statusText );
                }).finally(() => this.$store.dispatch('stop_loading'));
            },

            modal(item) {
                this.$store.dispatch('loading');
                let url = "/groups/" + item.id + "/members";

                HTTP.get(url).then(response => {
                    let resp = response.data;
                    let res = resp.responseData;
                    this.tbldataefedroi = [];
                    for(let i=0; i<res.length; i++)
                    {
                        this.tbldataefedroi.push({
                            'efOnoma' : res[i].efOnoma,
                            'efEpwnymo' : res[i].efEpwnymo,
                            'efsa' : res[i].efSa
                        });
                    }
                    $('#ModalValidate-'+item.id).modal('show');
                })
                .catch((error) => console.error(error))
                .finally(() => this.$store.dispatch('stop_loading'));
            }
        }    
    }
</script>